export default __webpack_public_path__ + "static/media/spinningball.9104c740.gif";